export class PaginationArgsBase {
	/**
	 * Limit how much rows to return
	 * @default 10
	 */
	limit?: number = 10;

	/**
	 * Paginate starting from 1
	 * @default 1
	 */
	page: number = 1;

	constructor({ limit, page }: PaginationArgsBase) {
		this.page = page;
		this.limit = limit;
	}
}
